import toast, { Toaster, ToastBar } from 'react-hot-toast';
import CrossIcon from 'Icons/closeThin.svg?react';

interface IToasterComponent {
    translations: {
        close: string;
    };
}

const ToasterComponent = ({ translations }: IToasterComponent) => (
    <Toaster
        containerStyle={{
            top: '16px',
        }}
        toastOptions={{
            duration: 6000,
            success: {
                style: {
                    border: `1px solid green`,
                    padding: '16px',
                    color: 'black',
                    background: '#ffffff',
                },
                iconTheme: {
                    primary: 'green',
                    secondary: '#FFFAEE',
                },
            },
            error: {
                icon: '',
                duration: 6000,
                style: {
                    padding: '20px',
                },
            },
        }}
    >
        {t => (
            <ToastBar toast={t} style={{ background: '#ffc0cb' }}>
                {({ icon, message }) => (
                    <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                            <button
                                className="absolute right-[-14px] top-[-14px] rounded-full border border-solid border-black bg-black p-[14px] text-white transition-all hover:scale-110"
                                name="dismiss"
                                onClick={() => toast.dismiss(t.id)}
                            >
                                <span className="sr-only">
                                    {translations.close}
                                </span>
                                <CrossIcon className="absolute right-0 top-0 m-2 h-3 w-3 stroke-2" />
                            </button>
                        )}
                    </>
                )}
            </ToastBar>
        )}
    </Toaster>
);

export default ToasterComponent;
